export const SEO_FEATURE_NAME = 'storyblok-seo';
